import { connect } from 'react-redux';
//
import Credit from 'components/sidebar/deal-management/credit/credit';
import { IStoreState } from 'store';
import { updateDealField, handleCreditPaymentTermCycleClick } from 'store/deal-edit/actions';
import { EPayCycle, EPaymentTerm } from 'store/deals/types';
import { TFieldValue } from 'store/deal-edit/types';

export interface ICreditProps {
  payDelay: number | null;
  stdPayDelay: number | null;
  probDefault: number | null;
  otherCredit: string | null | undefined;
  standardPaymentTermEndOfMonth: boolean;
  standardPaymentTermInvoiceDate: boolean;
  proposedPaymentTermEndOfMonth: boolean;
  proposedPaymentTermInvoiceDate: boolean;
  updateDealField: (field: string, value: TFieldValue) => void;
  handleCreditPaymentTermCycleClick: (payCycle: EPayCycle, paymentTerm: EPaymentTerm) => void;
}

const mapStateToProps = ({ dealEdit }: IStoreState) => {
  const { payCycle, payDelay, stdPayCycle, stdPayDelay, probDefault, otherCredit } = dealEdit;
  const props = {
    standardPaymentTermEndOfMonth: false,
    standardPaymentTermInvoiceDate: false,
    proposedPaymentTermEndOfMonth: false,
    proposedPaymentTermInvoiceDate: false,
    payDelay,
    stdPayDelay,
    probDefault,
    otherCredit,
  };

  if (payCycle) {
    props.proposedPaymentTermEndOfMonth = payCycle === EPayCycle.MONTH;
    props.proposedPaymentTermInvoiceDate = payCycle === EPayCycle.DELIVERY;
  }

  if (stdPayCycle) {
    props.standardPaymentTermEndOfMonth = stdPayCycle === EPayCycle.MONTH;
    props.standardPaymentTermInvoiceDate = stdPayCycle === EPayCycle.DELIVERY;
  }

  return props;
};

const mapDispatchToProps = {
  handleCreditPaymentTermCycleClick,
  updateDealField,
};

export default connect(mapStateToProps, mapDispatchToProps)(Credit);
